<template>
    <b-modal title="Itens da Prioridade" v-model="show" size="xl">
      <div class="modal-screen-list">
        <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
        <b-table bordered hover small head-variant="light" :items="getItens" :fields="fields.prioridadeItem">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>
        </b-table>
      </div>
  
      <template #modal-footer>
        <b-button variant="secondary" @click="show = !show">Fechar</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import { useSgcqStore } from "@/stores/SgcqStore";
  import { storeToRefs } from "pinia";
  import { usePrioridadeStore } from "@/stores/PrioridadeStore";
  import TableFields from "@/tools/TableFields";
  import Prioridade from "@/models/Prioridade";
  import PrioridadeItem from "@/models/PrioridadeItem";
  
  export default {
    name: "DashboardItensListModal",
  
    data() {
      return {
        show: false,
        fields: new TableFields(),
        prioridade: new Prioridade(0, "Nova Prioridade", "", "", new Date(), "não atendida"),
        itens: [],
        item: new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date()),
      };
    },
  
    methods: {  
      update() {
        this.prioridadeStore.LISTAR_ITENS(this.prioridade.id).then(() => {
          this.item = new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date());
          this.itens = this.getItens;
        });
      },
  
      call(prioridade) {
        this.show = !this.show;
        this.prioridade = prioridade;
        this.update();
      },
    },
  
    setup() {
      const store = useSgcqStore();
      const prioridadeStore = usePrioridadeStore();
      const { getItens } = storeToRefs(prioridadeStore);
  
      return {
        store,
        prioridadeStore,
        getItens,
      };
    },
  };
  </script>
  
  <style lang="scss" scoped></style>